import React, {Component} from 'react';
import { reduxForm, change} from 'redux-form';
import DataField from '../DataField/DataField';
import DataDisplay from '../DataDisplay/DataDisplay';
import DataActions from '../DataActions/DataActions';
import Rule from '@react/react-spectrum/Rule';
import { GridRow, GridColumn } from '@react/react-spectrum/Grid';
import Validator from '../validation';
import throwError from '../errorToast';
//import {page1_values} from '../../managepartnership/config/dummyvalues'

 
class DataSection extends Component {

    
    constructor(props)
    {
        super(props);
        this.state = {
            dataToggle:false,
            validation:{},
            errorShown: false
        }
    }

    componentDidMount(){
        this.onLoad();
    }
  
    checkValidation = (values) => {
        let validation = this.state.validation;
        this.props.field.map((item) => { 
            if(!Boolean(item.hide))
            {
                if(item.required)
                {
                    validation[item.name] = values[item.name] ? true : false ;
                }
                if(item.validator && values[item.name])
                {
                    const vr = Validator[item.validator](values[item.name]);
                    if(vr === "valid" || vr === true)
                    {
                        validation[item.name] = true;
                    }
                    else
                    {
                        validation[item.name] = false;
                    }
                }
                if(!item.required && !Boolean(values[item.name]))
                {
                    delete validation[item.name];
                }
            }
            else
            {
                if(Object.keys(validation).includes(item.name))
                {
                    delete validation[item.name];
                }
                else
                {
                    delete validation[item.name];
                }
            }
            return null;
        });
        this.props.updateValidation(this.props.sectionName,Object.values(validation).every(Boolean));
        this.setState({validation:validation});
    }

    onLoad = () => {
        const values = this.props.formStates ? this.props.formStates : {};
        this.props.field.map((item) => { 
            if(!Boolean(item.hide))
            {
                if(item.actions)
                {   
                    item.actions.map((action)=>{
                        if(typeof(DataActions[action.func]) === "function")
                        {
                            action.values = values;
                            DataActions[action.func](this.props,item,action,"onLoad")
                        }
                        return null;
                    })
                }
            }
            return null;
        });
       
        this.checkValidation(values);
    }

    onChange = (e,item) => {
        let values = this.props.formStates ? this.props.formStates : {};
        values[item.name] = e;
        if (item.key === 'pg3_1' || item.key === 'pg3_16') {
            if (!values[item.name].toLowerCase().includes("adobe")) {
                this.setState({ errorShown: false });
            }
            if (values[item.name].toLowerCase().includes("adobe")) {
                if (!this.state.errorShown) {
                    throwError("The value you entered is not valid");
                    this.setState({ errorShown: true });
                }
                return null;
            }
        }
        if(!Boolean(item.hide))
            {
                if(item.actions)
                {   
                    item.val = e;
                    item.actions.map((action)=>{
                        if(typeof(DataActions[action.func]) === "function")
                        {
                            action.values = values;
                            DataActions[action.func](this.props,item,action,"onChange")
                        }    
          
                        if(action.resetRequired) 
                        {
                            values[action.fieldName] = action.resetValue;
                            this.props.dispatch(change(this.props.form,action.fieldName,action.resetValue))
                        }
                        if(action.untouchRequired)
                        {
                            this.props.untouch(this.props.form, action.fieldName);
                        }
                        return null; 
                    })
                }
            }
        this.checkValidation(values);
        // this.setState({dataToggle:!this.state.dataToggle});
        return null;
    }

    onFocus = () => {
        //do nothing
    }

    onBlur = (e,item) => {
        let values = this.props.formStates ? this.props.formStates : {};
        if(Boolean(e.target.value))
        {
            values[item.name] = e.target.value;
        }
        this.checkValidation(values);
    }
        

    render(){
        let dataFields = [];
            this.props.field.map((item) => {
                if(!Boolean(item.hide))
                    {
                        if(this.props.mode === "nonEditable"){
                            dataFields.push(<DataDisplay key={item.name+this.props.formStates[item.name]} item={item} form={this.props.form}/>); 
                            dataFields.push(<GridRow key={item.name+"rule"}> 
                                <GridColumn size={[12,12,12,12]}>
                                        <Rule className="rule" variant="small" />
                                </GridColumn>
                        </GridRow>);
                        }
                        else{ 
                            dataFields.push(<DataField {...this.props} onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur} key={item.name} item={item} />);
                        }
                    }
                return null;
            }); 
    return <div>{dataFields}</div>;
    }
};

export default DataSection =  reduxForm({
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(DataSection);